<div class="main">
    <div class="container">
      <div class="header">
        <img
          src="../../../../../assets/images/logos/NanoH2O-Black@3x 1.png"
          alt="LG NanoH2O - Login"
          class="center"
          height="40"
          width="380"
        />
  
        <!-- <label class="" style="margin-top: 25px; font-size: larger; color:rgb(107,107,107);">Forgot Password</label> -->
      </div>
      <div style="background-color: rgb(255, 103, 39); height: 10px"></div>
      <form
        [formGroup]="ForgetPassForm"
        role="form"
        name="form"
        (ngSubmit)="onSubmit()"
      >
        <label
          style="
            padding-top: 15px;
            padding-bottom: 10px;
            font-size: medium;
            font-weight: bold;
          "
        >
        Your password has expired <br/>please provide your Username to receive a link to set a new password.
        </label>
        <input
          type="text"
          id="UserName"
          name="UserName"
          placeholder="Username"
          formControlName="UserName"
          (change)="validateUsername()"
          [ngClass]="{
            'is-invalid': submitted && ForgetPassForm.controls.UserName.errors
          }"
          class="form-control border border-dark"
        />
        <div
          *ngIf="submitted && ForgetPassForm.controls.UserName.errors"
          class="text-danger"
          style="text-align: left"
        >
          <span *ngIf="ForgetPassForm.controls.UserName.errors.required"
            >Username is required.</span
          >
        </div>
  
        <button type="submit">SUBMIT</button>
        <!-- <button type="button" onclick=""> </button> -->
      </form>
    </div>
  </div>
  